import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { toast } from 'sonner';
import { ArrowLeft, Mail } from 'lucide-react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

export const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const frontendUrl = window.location.origin;
      
      await axios.post(`${API}/api/auth/forgot-password`, {
        email,
        frontend_url: frontendUrl
      });

      setEmailSent(true);
      toast.success('Reset-Link wurde gesendet!');
    } catch (error) {
      console.error('Forgot password error:', error);
      toast.error('Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.');
    } finally {
      setLoading(false);
    }
  };

  if (emailSent) {
    return (
      <div
        className="min-h-screen flex items-center justify-center p-4 relative"
        style={{
          backgroundImage: `linear-gradient(rgba(15, 23, 42, 0.85), rgba(15, 23, 42, 0.85)), url('https://images.unsplash.com/photo-1632671414008-d3ea7df1dc4d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBnYXMlMjBzdGF0aW9uJTIwZXh0ZXJpb3IlMjBuaWdodHxlbnwwfHx8fDE3NjU4MzM3Nzh8MA&ixlib=rb-4.1.0&q=85')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <Card className="w-full max-w-md">
          <CardHeader className="space-y-1">
            <div className="flex justify-center mb-4">
              <img src="/allflowx-horizontal-light.png" alt="AllFlowX" className="h-24 w-auto object-contain dark:hidden" />
              <img src="/allflowx-horizontal-dark.png" alt="AllFlowX" className="h-24 w-auto object-contain hidden dark:block" />
            </div>
            <CardTitle className="text-2xl font-bold text-center flex items-center justify-center gap-2">
              <Mail className="h-6 w-6 text-green-600" />
              E-Mail gesendet!
            </CardTitle>
            <CardDescription className="text-center">
              Überprüfen Sie Ihr E-Mail-Postfach
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="p-4 bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 rounded-lg">
              <p className="text-sm text-green-900 dark:text-green-100 text-center">
                Falls ein Konto mit der E-Mail <strong>{email}</strong> existiert, wurde ein Reset-Link gesendet.
              </p>
              <p className="text-xs text-green-700 dark:text-green-300 mt-2 text-center">
                Der Link ist 1 Stunde gültig.
              </p>
            </div>

            <div className="space-y-2">
              <p className="text-sm text-gray-600 dark:text-gray-400 text-center">
                Keine E-Mail erhalten?
              </p>
              <ul className="text-xs text-gray-600 dark:text-gray-400 space-y-1 list-disc list-inside">
                <li>Überprüfen Sie Ihren Spam-Ordner</li>
                <li>Stellen Sie sicher, dass die E-Mail-Adresse korrekt ist</li>
                <li>Warten Sie einige Minuten und versuchen Sie es erneut</li>
              </ul>
            </div>

            <div className="pt-4 flex flex-col gap-2">
              <Button
                onClick={() => setEmailSent(false)}
                variant="outline"
                className="w-full"
              >
                Andere E-Mail verwenden
              </Button>
              
              <Link to="/login" className="w-full">
                <Button variant="ghost" className="w-full">
                  <ArrowLeft className="h-4 w-4 mr-2" />
                  Zurück zur Anmeldung
                </Button>
              </Link>
            </div>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div
      className="min-h-screen flex items-center justify-center p-4 relative"
      style={{
        backgroundImage: `linear-gradient(rgba(15, 23, 42, 0.85), rgba(15, 23, 42, 0.85)), url('https://images.unsplash.com/photo-1632671414008-d3ea7df1dc4d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBnYXMlMjBzdGF0aW9uJTIwZXh0ZXJpb3IlMjBuaWdodHxlbnwwfHx8fDE3NjU4MzM3Nzh8MA&ixlib=rb-4.1.0&q=85')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <Card className="w-full max-w-md">
        <CardHeader className="space-y-1">
          <div className="flex justify-center mb-4">
            <img src="/allflowx-horizontal-light.png" alt="AllFlowX" className="h-24 w-auto object-contain dark:hidden" />
            <img src="/allflowx-horizontal-dark.png" alt="AllFlowX" className="h-24 w-auto object-contain hidden dark:block" />
          </div>
          <CardTitle className="text-2xl font-bold text-center">
            Passwort vergessen?
          </CardTitle>
          <CardDescription className="text-center">
            Geben Sie Ihre E-Mail-Adresse ein, um Ihr Passwort zurückzusetzen
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="email">E-Mail</Label>
              <Input
                id="email"
                type="email"
                placeholder="ihre@email.de"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoFocus
              />
            </div>

            <Button
              type="submit"
              className="w-full"
              disabled={loading}
            >
              {loading ? 'Wird gesendet...' : 'Reset-Link senden'}
            </Button>
          </form>

          <div className="mt-4 text-center">
            <Link 
              to="/login" 
              className="text-sm text-primary hover:underline flex items-center justify-center gap-1"
            >
              <ArrowLeft className="h-4 w-4" />
              Zurück zur Anmeldung
            </Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
